import React from 'react';
import { Button } from 'react-bootstrap';
import styles from './ActionCard.module.scss';

interface IActionCard {
  titleSize?: 'sm' | 'lg';
  title: string | React.ReactNode;
  subtitle: string;
  description: string | React.ReactNode;
  onClick: () => void;
}

function getSize(size: 'sm' | 'lg' | undefined) {
  if (!size) {
    return '';
  }
  return styles[size];
}

const ActionCard = (props: IActionCard) => {
  return (
    <div className='col-sm-4 mb-3'>
      {/* <div className={styles.card}> */}
      <Button className={styles.card} variant='link' onClick={props.onClick}>
        <div className={`${styles.title} ${getSize(props.titleSize)}`}>
          <div>{props.title}</div>
        </div>
        <div className={styles.subtitle}>{props.subtitle}</div>
        <div className={styles.description}>{props.description}</div>
        {/* </div> */}
      </Button>
    </div>
  );
};

export default ActionCard;
